import { InputField, LabelTextWrapper, RequiredIndicator } from "./styled";
import InputMask from "react-input-mask";
import { formatData, formatDataBr } from "../../utils/functions-helper";
import { Input } from "antd";

type InputLabelProps = {
  disabled?: boolean;
  labelText?: string;
  labelId: string;
  type?: React.HTMLInputTypeAttribute;
  value?: string;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  required?: boolean;
  column?: boolean;
  placeholder?: string;
  tooltipText?: string;
  mask?: string;
  maxLength?: number;
};

function InputLabel({
  labelText,
  disabled,
  labelId,
  value,
  onChange,
  type,
  required,
  column,
  onBlur,
  tooltipText,
  placeholder,
  mask,
  maxLength,
}: InputLabelProps) {
  const formatNumberInput: (value: string) => string = (value: string) => {
    const numberPattern = /\d+/g;
    const newValue: RegExpMatchArray | null = value.match(numberPattern);

    return newValue ? newValue.join("") : "";
  };

  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    let newValue = value;
    if (type === "number") {
      newValue = formatNumberInput(value);
    }
    if (type === "date") {
      newValue = formatDataBr(value);
    }
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <InputField
      title={tooltipText}
      className={column ? "columnFormField" : ""}
      htmlFor={labelId}
    >
      <LabelTextWrapper>
        {required ? <RequiredIndicator>* </RequiredIndicator> : <></>}
        {labelText ? labelText + ":" : ""}
      </LabelTextWrapper>
      {type === "date" ? (
        <InputMask
          mask={"99/99/9999"}
          maskChar={null}
          name={labelId}
          value={formatData(value || "")}
          disabled={disabled}
          onChange={onChangeHandler}
          placeholder={placeholder}
          maxLength={maxLength}
          onBlur={() => {
            if (onBlur) {
              onBlur();
            }
          }}
        />
      ) : mask !== undefined && mask.length > 0 ? (
        <InputMask
          mask={mask}
          maskChar={null}
          name={labelId}
          value={value}
          disabled={disabled}
          onChange={onChangeHandler}
          placeholder={placeholder}
          onBlur={() => {
            if (onBlur) {
              onBlur();
            }
          }}
          maxLength={maxLength}
        />
      ) : type === "password" ? (
        <Input.Password
          name={labelId}
          value={value}
          disabled={disabled}
          onChange={onChangeHandler}
          placeholder={placeholder}
          onBlur={() => {
            if (onBlur) {
              onBlur();
            }
          }}
          maxLength={maxLength}
        />
      ) : (
        <Input
          name={labelId}
          value={value}
          disabled={disabled}
          onChange={onChangeHandler}
          placeholder={placeholder}
          onBlur={() => {
            if (onBlur) {
              onBlur();
            }
          }}
          type={type === "number" ? "text" : type}
          maxLength={maxLength}
        />
      )}
    </InputField>
  );
}

export default InputLabel;
